//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ExamsActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------


export const handleListApExams = () => async (dispatch) => {
    await dispatch(ExamsActions.listApExams());

    try {
        const apexams = await apis.get('apexams', `/list`);
        if (Array.isArray(apexams)) {
            await dispatch(ExamsActions.listApExamssSuccess(apexams));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing apexams',
                error,
                module: 'AP_EXAMS',
                operation: 'LIST_ACTIVITY'
            })
        }
        await dispatch(ExamsActions.listApExamssFail(error));
    }
};

export const handleCreateApExams = (data) => async (dispatch) => {
    await dispatch(ExamsActions.createApExams());
    try {
        const exam = await apis.post('apexams', `/create`, {
            body: data
        });
        if (has(exam, "id")) {
            await dispatch(ExamsActions.createApExamsSuccess(exam));
        }
        return exam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating apexams',
                error,
                module: 'AP_EXAMS',
                operation: 'CREATE_ACTIVITY'
            })
        }
        await dispatch(ExamsActions.createApExamsFail(error));
    }
};
export const handleUpdateApExams = (data) => async (dispatch) => {
    await dispatch(ExamsActions.updateApExams());
    try {
        const exam = await apis.put('apexams', `/update`, {
            body: data
        });
        if (has(exam, "id")) {
            await dispatch(ExamsActions.updateApExamsSuccess(exam));
        }
        return exam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating apexams',
                error,
                module: 'AP_EXAMS',
                operation: 'UPDATE_ACTIVITY'
            })
        }
        await dispatch(ExamsActions.updateApExamsFail(error));
    }
};
export const handleDeleteApExam = (id) => async (dispatch) => {
    await dispatch(ExamsActions.deleteApExams());
    try {
        const exam = await apis.del('apexams', `/delete/${id}`);
        if (has(exam, "id")) {
            await dispatch(ExamsActions.deleteApExamsSuccess(id));
        }
        return exam;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting apexams',
                error,
                module: 'AP_EXAMS',
                operation: 'DELETE_ACTIVITY'
            })
        }
        await dispatch(ExamsActions.deleteApExamsFail(error));
    }
};

export const handleListApExamDataByConfig = (data) => async (dispatch) => {
    try {
        const result = await apis.post('apexams', `/list_by_org`, {
            body: data
        });

        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing apexam data by config',
                error,
                module: 'AP_EXAMS',
                operation: 'LIST_ACTIVITY_DATA_BOOK_CLASS'
            })
        }
        return null;
    }
};
export const handleListApExamDataForGraphByConfig = (data) => async (dispatch) => {
    try {
        const result = await apis.post('apexams', `/dist_graph_data`, {
            body: data
        });

        return result;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing apexam data for graph by config',
                error,
                module: 'AP_EXAMS',
                operation: 'LIST_ACTIVITY_DATA_FEEDBACK_GROUP_BOOK_CLASS'
            })
        }
        return null;
    }
};